import { useFormik } from "formik"
import { TTab } from "providers/SettingsProvider/SettingsProviderTypes"
import { useMemo, useState } from "react"
import { REFUND_TABS } from "types/shared"
import * as Yup from "yup"

interface IBookingsFiltersState {
  current: boolean
  booked: boolean
  finished: boolean
  canceled: boolean
}
const BOOKING_EDIT_INIT_VALUES = {
  auto: "",
  number: "",
  changeService: "",
}

const carNumberReger =
  /^[ABCDEFGHJKLMNPRSTVWXYZ]{2}[0-9]{3}[ABCDEFGHJKLMNPRSTVWXYZ]{2}$/

const BOOKING_EDIT_SCHEMA = Yup.object({
  auto: Yup.string().required(""),
  number: Yup.string()
    .required("")
    .matches(carNumberReger, ""),
  changeService: Yup.string().required(""),
})

const useBookings = () => {
  const [searchValue, setSearchValue] = useState<string>("")
  const [filters, setFilters] = useState<IBookingsFiltersState>({
    current: false,
    booked: false,
    finished: false,
    canceled: false,
  })
  const [currentTab, setCurrentTab] = useState<TTab>(REFUND_TABS.PARTLY)

  const handleTabChange = (newTab: TTab) => setCurrentTab(newTab)

  const onSubmit = () => {
    console.log("submited")
  }

  const { values, errors, touched, handleChange, handleBlur, setValues  , handleSubmit} =
    useFormik({
      initialValues: BOOKING_EDIT_INIT_VALUES,
      validationSchema: BOOKING_EDIT_SCHEMA,
      onSubmit: onSubmit,
    })

  const updateFilters = (key: keyof IBookingsFiltersState, value: boolean) =>
    setFilters((currentFilters) => ({ ...currentFilters, [key]: value }))

  return useMemo(
    () => ({
      searchValue,
      setSearchValue,
      filters,
      updateFilters,
      currentTab,
      handleTabChange,
      form: {
        values,
        errors,
        touched,
        handleSubmit,
        handleChange,
        handleBlur,
        setValues,
      },
    }),
    [filters, values, errors, touched, currentTab],
  )
}

export default useBookings
